import React from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "./AlertOverview.scss";

function AlertOverview({ categories, dateRangeDisplay }) {
  const maxValue = Math.max(...categories.map((c) => c.value || 0), 0) || 1;

  return (
    <div className="alert-overview-card">
      <div className="alert-overview-header">
        <div className="header-left">
          <h3 className="stats-title">Alert Overview</h3>
          <p className="stats-subtitle">
            Number of alerts generated per day by category
          </p>
        </div>
        {dateRangeDisplay && (
          <div className="date-inline-display">
            <CalendarMonthIcon className="calendar-icon" />
            {dateRangeDisplay}
          </div>
        )}
      </div>

      <div className="alert-overview-rows">
        {categories.map((category) => (
          <div className="alert-overview-row" key={category.label}>
            <div className="alert-overview-label">{category.label}</div>
            <div className="alert-overview-track">
              <div
                className="alert-overview-fill"
                style={{
                  width: `${(category.value / maxValue) * 100}%`,
                  backgroundColor: category.color,
                }}
              />
            </div>
            <div className="alert-overview-value">{category.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AlertOverview;
